// import { initAuth, loginThunk } from "../../../redux/auth.reducer";
// import api from "../../../utils/useApi";

// let password = "NkZ+^64&*kF5x+Wn";

// const LoginUpdateProfile = async (
//   form,
//   mongoId,
//   navigate,
//   dispatch,
//   contry,
//   username
// ) => {

//   try {
//     if (mongoId && form.full_name && form.email) {
//       await api.put(`/profiles/${mongoId}`, {
//         full_name: form.full_name,
//         email: form.email,
//       });
//       dispatch(loginThunk({ username, password }));
//     } else {
//       alert("Please fill all fields");
//     }
//   } catch (error) {
//     console.error("LoginUpdateProfile", error);
//   }
// };

// export default LoginUpdateProfile;

import { initAuth, loginThunk } from "../../../redux/auth.reducer";
import api from "../../../utils/useApi";

let password = "NkZ+^64&*kF5x+Wn";

export const FunctionCheckEmail = (input, alert) => {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isEmail = emailRegex.test(String(input).toLowerCase());
  if (isEmail) {
    return "";
  } else {
    return alert;
  }
};

const LoginUpdateProfile = async (
  form,
  mongoId,
  navigate,
  dispatch,
  contry,
  username,
  setLoading,
  user
) => {
  try {
    const emailAlert = FunctionCheckEmail(
      form.email,
      "Please enter a valid email"
    );
    if (emailAlert) {
      alert(emailAlert);
      return;
    }
    setLoading(true);
    if (form.full_name && form.email) {
      const thisUsername = sessionStorage.getItem("pre-data");
      await api.put(`/profiles/${thisUsername}`, {
        full_name: form.full_name,
        email: form.email,
      });

      if (user?._id) {
        dispatch(initAuth());
      } else {
        sessionStorage.setItem("create-new", true);
        dispatch(loginThunk({ username: thisUsername }));
      }
    } else {
      alert("Please fill all fields");
    }
  } catch (error) {
    console.error("LoginUpdateProfile", error);
  }
};

export default LoginUpdateProfile;
